import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const ScheduleSurgeryContainer = styled.div`
    display: flex;
    flex-direction: column;
    font-family: AvenirNextWorld Regular;
    margin: 10px 16px;
    position: relative;
    background: #ffffff 0% 0% no-repeat padding-box;
    width: cal(100%-20px);
    ${media.portraitDevice`
        box-shadow: 0px 0px 6px #00000029;
        padding: 26px 24px;
    `}
`;
